import React from "react";
import { Box, Typography, CardContent } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { TimeslotStatsDto } from "../../../shared/dtos/timeslot/TimeslotStatsDto";

interface TimeslotOverviewWidgetProps {
  data: TimeslotStatsDto;
}

const TimeslotOverviewWidget: React.FC<TimeslotOverviewWidgetProps> = ({
  data,
}) => {
  const meta = getEntityMeta("TIMESLOT");
  const Icon = meta.icon;

  const chartData =
    data.slotsPerDay?.map((item) => ({
      day: item.dayOfWeek.substring(0, 3).toUpperCase(),
      count: item.count,
    })) || [];

  return (
    <StyledCard
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <CardContent
        sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {meta.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Total Defined: {data.totalDefinedSlots}
            </Typography>
          </Box>
        </Box>

        {chartData.length > 0 ? (
          <Box sx={{ flexGrow: 1, width: "100%", minHeight: 200 }}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={chartData}
                margin={{ top: 5, right: 10, left: -20, bottom: 0 }}
              >
                <XAxis dataKey="day" tick={{ fontSize: 12 }} />
                <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
                <Tooltip />
                <Bar dataKey="count" fill={meta.color} radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
              minHeight: 200,
            }}
          >
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", fontStyle: "italic" }}
            >
              No timeslots defined yet.
            </Typography>
          </Box>
        )}
      </CardContent>
    </StyledCard>
  );
};

export default TimeslotOverviewWidget;
